import { Autocomplete, TextField } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { useState } from "react"
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const TextSearchableCellEditor = forwardRef((props, ref) => {
    const [searchList, setSearchList] = useState([]);
    const [fieldValue, setFieldValue] = useState(props.value);
    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.performance}`;

    useEffect(() => {
        if (fieldValue) {
            if(props.column.colId === 'keyResultValue'){
                console.log(props.data);
                const getlist = async () => {
                    try {
    
                        const list = await OAuthService.getList(url + `/getKeyResult/${props.data.objectiveValue}?value=` + fieldValue)
                        if (list?.data) {
                            
                            setSearchList(list?.data)
                        }
                    } catch (error) {
    
                    }
                }
                getlist()

            }else if(props.column.colId === 'objectiveValue'){
                const getlist = async () => {
                    try {
    
                        const list = await OAuthService.getList(url + '/getObjective?value=' + fieldValue)
                        if (list?.data) {
                          
                            setSearchList(list?.data)
                        }
                    } catch (error) {
    
                    }
                }
                getlist()
            }
        } else {
            setSearchList([])
        }
    }, [fieldValue]);

    const handleInputChange = (event, value) => {
        setFieldValue(value)
    }

    useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return fieldValue;
            }
        };
    });

    return (
        <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={searchList}
            sx={{minWidth:'250px'}}
            value={fieldValue}
            onChange={handleInputChange}
            onInputChange={handleInputChange}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        type: 'search',
                    }}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
    )
})

export default TextSearchableCellEditor